import type { RootState } from "../../app/store.js";

export const selectProjectLinkState = (state: RootState) => state.projectLink;

export const selectProjectShortId = (state: RootState) =>
  state.projectLink.project ? state.projectLink.project.short_id : null;
